import { AxiosInstance } from 'axios';
import { IFillSelect } from '../interface/generic/IFillSelect';
import { ApiService } from '../model/Api.model';

enum NatureTypeServiceEnum {
	base = '/',
}

export default class NatureTypeService extends ApiService {
	constructor(restClient: AxiosInstance) {
		super(restClient, '/nature-type');
	}

	public getAll = async (): Promise<IFillSelect[]> => await this.GET(NatureTypeServiceEnum.base);
}
